import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { EXTEND_TIME_SESSION, EXTEND_TIME_SESSION_SUCCESS, EXTEND_TIME_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* ExtendTimeSession({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { ticketId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/increment-customer-sessions/${ticketId}`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: EXTEND_TIME_SESSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: EXTEND_TIME_SESSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: EXTEND_TIME_SESSION_ERROR, payload: error });
  }
}

export function* watchExtendTimeSession() {
  yield takeEvery(EXTEND_TIME_SESSION, ExtendTimeSession);
}

function* extendTimeSessionSaga() {
  yield all([fork(watchExtendTimeSession)]);
}

export default extendTimeSessionSaga;
